<template>
    <div class="landing">
        <el-row>
            <div class="landing-header-container">
                <Ticker />
                <Header class="landing-header">
                    <div class="landing-header-left" v-if="!isMobile()">
                        <div class="landing-header-title">
                            Chicago Athenaeum Museum of Architecture and Design
                        </div>
                        <div class="landing-header-title">
                            European Centre for Architecture Art Design and
                            Urban Studies
                        </div>
                    </div>
                    <div class="landing-header-middle">
                        <a href="https://awardapplication.com/">
                            <div class="landing-header-title">
                                TCA - ECADUS <br />
                                AWARDS SUBMISSION PAGE
                            </div>
                        </a>
                    </div>
                </Header>
            </div>
        </el-row>
        <el-row
            style="margin-top: 60px; display: flex; justify-content: center"
        >
            <div style="width: 1600px">
                <h1><strong>Returns</strong></h1>
                <p>
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), is the registered title
                    of a publication house running under The European Centre for
                    Architecture Art Design and Urban Studies in a collaboration
                    with The Chicago Athenaeum Museum of Architecture and
                    Design.
                </p>
                <h1><strong>Orders</strong></h1>
                <p>
                    All orders are binding. In case of delivery delays you will
                    be informed as quickly as possible via e-mail.
                </p>
                <h1><strong>Prices and Descriptions</strong></h1>
                <p>
                    Our prices are recommended sales prices including the
                    legally prescribed VAT.
                </p>
                <h1>
                    <strong
                        >Payment Information - Credit Card - Bank
                        Transfer</strong
                    >
                </h1>
                <p>
                    Your payment transaction will be handled by Elavon bank via
                    a certified, secure HTTPS connection. You will receive an
                    invoice from Metropolitan Arts Press Ltd. For Submissions
                    for the Good Design and American Architecture and from The
                    European Centre for Architecture Design and Urban Studies
                    for submissions for Green Good Design, International
                    Architecture Awards and Europe 40under40 Design Award via
                    e-mail.
                </p>
                <h1>
                    <strong>Type and Time of Invoice Delivery</strong>
                </h1>
                <p>
                    Your order will be processed immediately. In the case of
                    delays you will be informed. The delivery time of the
                    invoice is determined by the type of payment either bank
                    transfer or credit card.
                </p>
                <h1>
                    <strong>Reservation of Proprietary Rights</strong>
                </h1>
                <p>
                    Until receipt of payment the goods remain the property of
                    the publisher. In the case of late payment the publisher has
                    the right to withdraw from the contract and to request
                    return of the purchased goods.
                </p>
                <h1>
                    <strong>Cancellation of Orders</strong>
                </h1>
                <p>
                    Orders can be cancelled at any time. We will take back goods
                    which have already been delivered in perfect, condition
                    within 14 days against a credit note. Please always give
                    your invoice number and the reason for return. The return of
                    the goods shall be done at the risk and expense of the
                    customer
                </p>
                <h1>
                    <strong
                        >Errors in Fulfilling Orders or Production
                        Defects</strong
                    >
                </h1>
                <p>
                    In the case of errors in fulfilling orders or production
                    defects we will exchange the item in question for one in
                    perfect condition.
                </p>
                <h1>
                    <strong>Privacy Policy</strong>
                </h1>
                <p>
                    Metropolitan Arts Press Ltd. is running under The Chicago
                    Athenaeum Museum of Architecture in a βcollaboration with
                    The European Centre for Architecture Design and Urban
                    Studies and Design. It has committed themselves to protect
                    the privacy of all persons who use our website. No personal
                    information regarding the user will be shared with any
                    outside person orcompany.
                </p>
                <h1>
                    <strong>Court of Jurisdiction</strong>
                </h1>
                <p>Court of Jurisdiction is Illinois, USA.</p>
            </div>
        </el-row>
        <el-row>
            <footer>
                <!-- Footer main -->
                <section class="ft-main">
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Awards Organizers</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.chi-athenaeum.org/"
                                    target="_blank"
                                    >The Chicago Athenaeum</a
                                >
                            </li>
                            <li>
                                <a
                                    href="http://europeanarch.eu/"
                                    target="_blank"
                                    >The European Centre</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Legal</h2>
                        <ul>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'terms-and-conditions',
                                    }"
                                    target="_blank"
                                >
                                    Terms & Conditions
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'refund-policy',
                                    }"
                                    target="_blank"
                                >
                                    Refund Policy
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Connect</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.instagram.com/thechicagoathenaeummuseum/"
                                    target="_blank"
                                    >Instagram</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm"
                                    target="_blank"
                                    >Facebook</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.youtube.com/@thechicagoathenaeummuseum"
                                    target="_blank"
                                    >Youtube</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Contact</h2>
                        <ul>
                            <li>
                                <a href="#">curatorial@chi-athenaeum.org</a>
                            </li>
                            <li>
                                <a href="#"
                                    >tel: +1 815 777 4444 (extension 3000)</a
                                >
                            </li>
                        </ul>
                    </div>
                </section>
                <!-- Footer legal -->
                <section class="ft-legal">
                    &copy; 2024 - 2026 All rights reserved for The Chicago
                    Athenaeum Museum of Architecture and Design , European
                    centre for Architecture Art Design and Urban Studies,
                    Metropolitan Arts Press Ltd.
                </section>
            </footer>
        </el-row>
    </div>
</template>
<script>
import Footer from "@/core/components/Footer";
import Ticker from "@/core/components/Ticker.vue";

export default {
    components: {
        Ticker,
        Footer,
    },
    methods: {
        isMobile() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
<style>
ul {
    list-style: none;
    padding-left: 0;
}
footer {
    line-height: 1.5;
}
footer a {
    text-decoration: none;
}
a {
    color: #000000;
}
a:hover {
    text-decoration: underline;
}
.ft-title {
    font-weight: bold;
    font-size: 16px;
}
body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}
.container {
    flex: 1;
}
.ft-main {
    padding: 1.25rem 1.875rem;
    display: flex;
    flex-wrap: wrap;
}
@media only screen and (min-width: 29.8125rem /* 477px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
@media only screen and (min-width: 77.5rem /* 1240px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
.ft-main-item {
    padding: 1.25rem;
    min-width: 12.5rem;
    .line {
        width: 100%;
        border: 1px solid #000;
        margin: 3px;
        display: inline-block;
    }
}
.ft-legal {
    display: flex;
    justify-content: center;
    align-items: center;
}
.landing-tutorial {
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 16px;
    width: 100%;
    justify-content: center;
    margin-top: 30pt;
    a {
        text-decoration: underline;
    }
    img {
        display: none;
    }
    @media (max-resolution: 1dppx) {
        font-size: 30px;
        text-align: left;
        img {
            width: 110px;
            height: 85px;
            display: inline;
        }
    }
}
</style>
